var map = {
	"./y1.jpg": "0352",
	"./y10.jpg": "07ee",
	"./y11.jpg": "a235",
	"./y12.jpg": "2627",
	"./y13.jpg": "dce1",
	"./y14.jpg": "5b88",
	"./y15.jpg": "a481",
	"./y16.jpg": "c04b",
	"./y17.jpg": "ca67",
	"./y18.jpg": "746f",
	"./y19.jpg": "2f7b",
	"./y2.jpg": "f7c8",
	"./y20.jpg": "326d",
	"./y21.jpg": "7a9a",
	"./y22.jpg": "fb8e",
	"./y23.jpg": "e8c9",
	"./y3.jpg": "2e8c",
	"./y4.jpg": "364e",
	"./y5.jpg": "0dd1",
	"./y6.jpg": "f909",
	"./y7.jpg": "eb08",
	"./y8.jpg": "c2ef",
	"./y9.jpg": "2eac",
	"./yyzz.jpg": "5f72"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a497";